import { KeyValue } from './common.types';
import React from 'react';

export interface SMSAndTalkTime {
  sms: {
    unit?: string;
    quantity: string;
  };
  talktime: {
    unit?: string;
    quantity: string;
  };
}

export interface PlanState extends SMSAndTalkTime {
  readonly basePriceSchemaId: string;
  data: {
    unit?: string;
    quantity: string;
  };
  enabledOnPlanCatalog: boolean;
  enabledOnPhoneCatalog: boolean;
  enabledOnPhoneDetail: boolean;
  groupName: string;
  mecId: string;
  monthlyCharges: string;
  discountedPrice: string;
  discountedLiner: string;
  phoneCost: string;
  planDescSubLiner?: string;
  planId: string;
  planName: string;
  planRelId: string;
  ribbon?: string;
  selected: boolean;
  tags?: string[];
}

export interface PlanGroup {
  defaultPlan?: string;
  groupName: string;
  groupDisplayName: string;
  shortDescription: string;
  segment: string[];
  enabledOnPhoneCatalog?: boolean;
}
export interface Plan extends KeyValue {
  groupName: string;
  enabledOnPlanCatalog: boolean;
  enabledOnPhoneCatalog: boolean;
  enabledOnPhoneDetail: boolean;
  selected: boolean;
  mecId: string;
  planId: string;
  basePriceSchemaId: string;
  planRelId: string;
  planName: string;
  monthlyCharges: string | number;
  discountedPrice?: string;
  discountedLiner?: string;
  phoneCost: string;
  ribbon: null;
  planDescSubLiner: string;
  mainlineGroup: string;
  tags: string[];
  data?: {
    unit: string;
    quantity: number;
  };
  selectedMonthlyTerm?: string;
}

export enum FLOW {
  RES = 'res',
  CIS = 'cis',
  PUBLIC = 'public'
}

export enum BANNER_FLOW_TYPE {
  RES_CATALOG = 'resCatalog',
  RES_PLAN = 'resPlan',
  CIS_CATALOG = 'cisCatalog',
  CIS_PLAN = 'cisPlan'
}

export interface Subscription extends KeyValue {
  id: string;
  status: string;
  serviceId: string;
  offeringId: string;
  offeringName: string;
  offeringDescription: string;
  bundle: boolean;
  customerId: string;
  subscriptionId: string;
  subscriptionType: string;
  recontractEligibility: {
    isEligible: boolean;
    ineligibleCode: string;
    ineligibleReason: string;
  };
}

export interface CustomerDetails {
  eligible: boolean;
  serviceLines: number[];
}

export interface MobileBTLOffer {
  price: {
    offerPrice: string;
    normalPrice: number;
  };
  plan: {
    BOID: number;
    discountBOID: number;
    contractDuration: string;
  };
  vas: Array<{
    type: string;
    BOID: number;
    vasDuration: number;
    discountBOID: number;
  }>;
  rebate: {
    rebateBOID: number;
  };
  displayItems: {
    imageURL: number;
    title: number;
    description: string[];
  };
}

export interface BTLOfferDetails {
  customerDetails: CustomerDetails;
  mobile: MobileBTLOffer[];
}

export interface IconWithTextContent {
  icon?: string;
  text?: string;
  alignItems?: string;
}

export interface SelectedContent {
  duration?: string;
  planName?: string;
  currentPrice?: string;
  originalPrice?: string;
  planImage?: string;
  planImageAlt?: string;
  iconWithTextContent?: IconWithTextContent[];
  bulletlistTitle?: string;
  bulletlistContent?: Array<string | React.ReactNode>;
  subscriptionsTitle?: string;
  subscriptions?: Array<string | React.ReactNode>;
}

export interface BTLActionLayoutModel {
  id: string;
  title: string;
  subtitle?: string;
  ribbonText?: string;
  selectedContent?: SelectedContent;
}

export interface SubscriptionsList {
  image: string,
  imageAlt: string,
  title: string,
  subTitle: string,
}
